export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';

export const MOBILE_BREAKPOINT = 768;

export function getDeviceType(screenWidth) {
  if (screenWidth < MOBILE_BREAKPOINT) {
    return MOBILE;
  }
  return DESKTOP;
}
